import {Component, OnInit, OnDestroy} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {LoadingService} from '../../services/loading/loading.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {AlertService} from '../../services/alert/alert.service';
import {CarrierLocalAgentService} from '../../services/carrier-local-agent/carrier-local-agent.service';
import AppConstants from '../../shared/common-components/AppConstants';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import {Carrier} from 'src/app/services/carrier/carrier';
import {UserService} from '../../services/user/user.service';
import {CarrierLocalAgentsEntity} from 'src/app/shared/common-components/common-structure';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'app-carrier-local-agents',
    templateUrl: './carrier-local-agents.component.html',
    styleUrls: ['./carrier-local-agents.component.css'],
    standalone: false
})
export class CarrierLocalAgentsComponent implements OnInit, OnDestroy {

  localAgentsGridOptions: GridOptions = this.initializeGridOptions();
  private observer$ = new BehaviorSubject(true);
  carrierLocalAgentsForm: UntypedFormGroup;
  carrierLocalAgentsEntity: CarrierLocalAgentsEntity;
  carrier: Carrier;
  carrierId: string;
  isCreate: boolean;
  carierLocalAgentsList = [];
  scacCodeList: string[] = [];
  agentStatusList: string[] = [];
  typeaheadlist: string[] = [];
  minLengthToSearch: number;
  maxCharLength: number;
  gridApi: any;
  columnDefs: any;
  public overlayNoRowsTemplate;

  mySubscription: any;

  constructor(private fb: UntypedFormBuilder, public loader: LoadingService, private modalService: BsModalService,
              private alertService: AlertService, private carrierLocalAgentService: CarrierLocalAgentService, private userService: UserService, private router: Router,) {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });
  }

  ngOnInit() {
    this.createForm();
  }

  /**
   * @description intializes all the form controls
   */
  createForm() {

    this.carrierLocalAgentsForm = this.fb.group({
      agentScac: new UntypedFormControl('', Validators.required),
      agentName: new UntypedFormControl('', Validators.required),
      agentEmail: new UntypedFormControl('', Validators.required),
      agentPhone: new UntypedFormControl('', Validators.required),
      agentStatus: new UntypedFormControl('', Validators.required)
    });
    this.agentStatusList.push('Active');
    this.agentStatusList.push('Deleted');
    this.userService.getCurrentUserObservable().subscribe(currentUser => {
      if (currentUser) {
        this.carrierId = currentUser.carrierId;
        this.onAgentScacSearch();
      }
    }, (error) => {
      console.log('ERROR WHILE RETRIVING DATA', error);
      // this.alertService.info('unable to get current user details');
    });
  }

  typeaheadScacOnSelect(e: TypeaheadMatch): void {
    this.carrierLocalAgentsForm.get('agentScac').setValue(e.item);
    for (const carrierLocalAgentsOutput of this.carierLocalAgentsList) {
      if (e.item == carrierLocalAgentsOutput.agentScac) {
        this.carrierLocalAgentsEntity = carrierLocalAgentsOutput;
        this.carrierLocalAgentsForm.controls['agentScac'].disable();
        this.carrierLocalAgentsForm.get('agentName').setValue(carrierLocalAgentsOutput.agentName);
        this.carrierLocalAgentsForm.get('agentEmail').setValue(carrierLocalAgentsOutput.agentEmail);
        this.carrierLocalAgentsForm.get('agentPhone').setValue(carrierLocalAgentsOutput.agentPhone);
        this.carrierLocalAgentsForm.get('agentStatus').setValue(carrierLocalAgentsOutput.agentStatus);
      }
    }
  }

  onAgentScacSearch() {
    this.carrierLocalAgentService.getAllCarrierLocalAgentsByCarrierId(this.carrierId)
      .subscribe(carierLocalAgentsList => {
        this.carierLocalAgentsList = carierLocalAgentsList;
        for (const carrierLocalAgentsOutput of carierLocalAgentsList) {
          this.scacCodeList.push(carrierLocalAgentsOutput.agentScac);
        }
        this.minLengthToSearch = 1;
        this.maxCharLength = 4;
        this.typeaheadlist = this.scacCodeList;
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.error('There was an error retrieving Carrier Local Agents Scac');
      });
    this.loader.show();
  }

  onSaveOrEditClicked(modifyType: string) {
    if (!this.carrierLocalAgentsEntity) {
      this.carrierLocalAgentsEntity = new CarrierLocalAgentsEntity;
      this.carrierLocalAgentsEntity.agentScac = this.carrierLocalAgentsForm.get('agentScac').value;
    }
    this.carrierLocalAgentsEntity.agentName = this.carrierLocalAgentsForm.get('agentName').value;
    this.carrierLocalAgentsEntity.agentEmail = this.carrierLocalAgentsForm.get('agentEmail').value;
    this.carrierLocalAgentsEntity.agentPhone = this.carrierLocalAgentsForm.get('agentPhone').value;
    this.carrierLocalAgentsEntity.agentStatus = this.carrierLocalAgentsForm.get('agentStatus').value;
    this.carrierLocalAgentsEntity.updateId = Number(this.carrierId);
    this.carrierLocalAgentsEntity.carrierId = Number(this.carrierId);

    if (modifyType === 'update') {
    } else if (modifyType === 'save') {
      // API call for Saving package
      this.loader.show();
      this.carrierLocalAgentService.saveCarrierLocalAgents(this.carrierLocalAgentsEntity).subscribe(newCarrierLocalAgentsEntity => {
        this.loader.hide();
        // update list
        this.alertService.success('The Local Agent Details has been successfully Added');
        this.onAgentScacSearch();
      }, () => {
        this.loader.hide();
        this.alertService.error('There was an error Adding Local Agents');
      });
    }
  }

  onAddButtonClick() {
    this.carrierLocalAgentsForm.controls['agentScac'].enable();
    this.carrierLocalAgentsForm.get('agentScac').setValue('');
    this.carrierLocalAgentsForm.get('agentName').setValue('');
    this.carrierLocalAgentsForm.get('agentEmail').setValue('');
    this.carrierLocalAgentsForm.get('agentPhone').setValue('');
    this.carrierLocalAgentsForm.get('agentStatus').setValue('');
  }

  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'single',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      rowData: this.carierLocalAgentsList,
      columnDefs: this.getLocalAgentsGridColumnDefs(),
      onGridReady: (params) => {
        this.gridApi = params.api;
        this.onResizeTable(params);
      },
      onRowDataChanged: params => {
        this.gridApi = params.api;
        this.onResizeTable(params);
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  onResizeTable(e: any) {
    e.api.sizeColumnsToFit();
  }

  getLocalAgentsGridColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: ' SCAC',
          field: 'agentScac',
          filter: 'agTextColumnFilter',
          cellRenderer: params => {
            if (AppConstants.isNotNullCondition(params)) {
              return '<a tabindex="0">' + params.data.agentScac + '</a>';
            } else {
              return params.data.agentScac;
            }
          },
          onCellClicked: event => this.onSCACClicked(event.data)
        },
      {
        headerName: 'Name',
        field: 'agentName',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Phone',
        field: 'agentPhone',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Email',
        field: 'agentEmail',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Status',
        field: 'agentStatus'
      }
    ];
  }

  onSCACClicked(carrierLocalAgentsEntity: CarrierLocalAgentsEntity) {
    this.carrierLocalAgentsEntity = carrierLocalAgentsEntity;
    this.carrierLocalAgentsForm.controls['agentScac'].disable();
    this.carrierLocalAgentsForm.get('agentScac').setValue(carrierLocalAgentsEntity.agentScac);
    this.carrierLocalAgentsForm.get('agentName').setValue(carrierLocalAgentsEntity.agentName);
    this.carrierLocalAgentsForm.get('agentEmail').setValue(carrierLocalAgentsEntity.agentEmail);
    this.carrierLocalAgentsForm.get('agentPhone').setValue(carrierLocalAgentsEntity.agentPhone);
    this.carrierLocalAgentsForm.get('agentStatus').setValue(carrierLocalAgentsEntity.agentStatus);
  }

  /**
   * destroying the subscription
   */
  ngOnDestroy(): void {
    this.observer$.next(false);
  }
}
